<script>
import baseFlexColumn from '@/components/base/base-flex-column'

export default {
  components: {
    'base-flex-column': baseFlexColumn
  },
  computed: {
    tv () {
      return this.docs.onair.tv
    },
    nf () {
      return this.docs.onair.nf
    }
  }
}
</script>

<template>
  <div class="gp-streaming">
    <div class="page-background"></div>

    <h1 class="page-title">STREAMING</h1>

    <base-flex-column class="contents-container" gap="60">
      <base-flex-column
        class="has-text-weight-bold has-text-align-center"
        tag="section"
        gap="32"
      >
        <base-flex-column tag="h2" gap="24">
          <img
            src="/assets/images/top-visual-4-logo.png"
            alt="GREAT PRETENDER razbliuto"
          />
          <span>2024年、全世界展開決定！</span>
        </base-flex-column>

        <base-flex-column gap="48">
          <base-flex-column gap="16">
            <base-flex-column gap="4">
              <h3>日本国内</h3>
              <p>2月23日（金）0:00～<br />DMM TV独占作品として展開</p>
            </base-flex-column>

            <a
              href="https://tv.dmm.com/vod/"
              target="_blank"
              rel="noopener"
            >
              <img class="logo-dmm" src="/assets/images/logo-dmm-b.svg" alt="DMM TV ORIGINAL" />
            </a>
          </base-flex-column>

            <base-flex-column gap="4">
              <h3>中東・北アフリカ地域<sup class="is-size-5">※1</sup></h3>
              <p>マンガプロダクションズによる展開</p>
            </base-flex-column>

          <base-flex-column gap="4">
            <h3>その他全世界<sup class="is-size-5">※2</sup></h3>
            <p>クランチロール<br>1月9日～10日 北米地域での劇場上映決定！</p>
          </base-flex-column>

        <p class="caption is-size-6 has-text-weight-normal has-text-align-left">
          ※1）アルジェリア、バーレーン、エジプト、イラク、ヨルダン、クウェート、レバノン、リビア、モロッコ、オマーン、パレスチナ、カタール、サウジアラビア、シリア、チュニジア、アラブ首長国連邦、イエメン、スーダン<br />
          ※2）中国本土を除く
        </p>
        </base-flex-column>
      </base-flex-column>

      <hr />

      <section class="nf has-text-weight-bold has-text-align-center">
        <base-flex-column gap="24">
          <base-flex-column tag="h2" gap="32">
            <img
              src="/assets/images/logo-gp-b-w_2x.png"
              alt="GREAT PRETENDER"
            />
            <span>Netflix、FODほかにて配信中</span>
          </base-flex-column>

          <div class="logo level-center is-mobile">
            <a
              href="https://www.netflix.com/jp/"
              target="_blank"
              rel="noopener"
            >
              <img
                class="logo-netflix"
                src="/assets/images/logo-netflix.svg"
                alt="Netflix"
              >
            </a>

            <a
              href="https://fod.fujitv.co.jp/s/genre/anime/ser5f65/"
              target="_blank"
              rel="noopener"
            >
              <img
                class="logo-fod"
                src="/assets/images/logo-fod.png"
                alt="FOD"
              >
            </a>
          </div>
        </base-flex-column>
      </section>
    </base-flex-column>
  </div>
</template>

<style lang="scss" scoped>
.gp-streaming {

  .contents-container {
    @include is-mobile  {
      padding: 0 1rem;
    }

    @include is-not-mobile  {
      max-width: 60rem;
      padding: 0 2rem;
      margin: auto;
    }
  }
  section {
    h1 {
      color: $orange;
      background-color: $black;
      line-height: 2rem;
      @include is-mobile {
        margin: 0 1rem;
      }
      @include is-not-mobile {
        width: 22rem;
        margin: auto;
      }
    }

    h2 {
      @include is-mobile {
        font-size: 1.875rem;
        margin: 0 1.5rem;
        line-height: 2.25rem;
      }
      @include is-not-mobile {
        font-size: 2.5rem;
        margin: 0 1.5rem;
        line-height: 3rem;
      }

      img {
        width: 14rem;
        margin: auto;
      }
    }

    h3 {
      @include is-mobile {
        font-size: 1.625rem;
        margin: 0 1.5rem;
        line-height: 2.25rem;
      }
      @include is-not-mobile {
        font-size: 1.875rem;
        margin: 0 1.5rem;
        line-height: 3rem;
      }
    }

    p {
      @include is-mobile {
        font-size: 1.375rem;
      }

      @include is-not-mobile {
        font-size: 1.5rem;
      }
    }

    .caption {
      @include is-mobile {
        margin: auto;
      }

      @include is-not-mobile {
        width: 40rem;
        margin: auto;
      }
    }

    .logo-dmm {
      height: 3.5rem;
      margin: auto;
    }

    .logo {
      @include is-mobile {
        gap: 2.5rem;
      }

      @include is-not-mobile {
        gap: 3rem;
      }

      img {
        @include is-mobile {
          height: 2rem;
        }

        @include is-not-mobile {
          height: 2.5rem;
        }
      }
    }
  }

  hr {
    height: .5rem;
    border: none;
    background-color: #000;

    @include is-mobile {
      width: calc(100% - 6rem);
    }

    @include is-not-mobile {
      width: 22rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/streaming.vue